exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2f69UKqsYrU4QiGYwSEvcm{width:236px}", ""]);
// Exports
exports.locals = {
	"categoriesMenuContainer": "_2f69UKqsYrU4QiGYwSEvcm"
};